import PropTypes from 'prop-types';
import React from "react";
import { Image, Row, Col } from "react-bootstrap";
import BackButton from "src/legacy/components/BackButton";
import DeactivateIntegrationContainer from "src/legacy/components/DeactivateIntegration/index";
import ExternalScriptEditorPage from "./ExternalScriptEditorPage";
import ReactfulIcon from "src/legacy/images/js_logo.png";
import styles from "./styles.module.scss";
import { localizedStrings } from 'src/localization/index.jsx';
import { shouldFetchIntegrations } from 'src/legacy/redux/actions/integrations';

class ExternalScriptView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      deleteConfirmation: false,
    };
    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedExternalScripts = localizedStrings.components.integrations.external_scripts;

  }

  _handleDeactivateClicked() {
    this.setState({
      deleteConfirmation: true,
    });
  }

  componentDidMount() {

    if(shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }
  }

  render() {
    return (
      <div className={styles.content} fluid>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            <BackButton
              className={styles.back}
              title={this.localizedCommons.actions.back}
              onClick={() => {
                this.props.navigate("/settings/integrations");
              }}
            />

            <div className={styles.heading}>
              <Image src={ReactfulIcon} />
              <h2 className={styles.name}>{ this.localizedExternalScripts.title }</h2>
              <p className={styles.description}>
                  { this.localizedExternalScripts.sub_text }
              </p>
              {this.props.integration && (
                <button
                  className={styles.button}
                  disabled={this.props.deactivating}
                  onClick={this._handleDeactivateClicked}
                >
                  {this.props.deactivating && `${this.localizedIntegrations.actions.deactivating}...`}
                  {!this.props.deactivating && this.localizedIntegrations.actions.deactivate }
                </button>
              )}
            </div>
          </Col>
          <Col md={9} className={styles.right}>
            <ExternalScriptEditorPage
              store={this.context.store}
              integration={this.props.integration}
            />
          </Col>
        </Row>
        <DeactivateIntegrationContainer
          name={this.localizedExternalScripts.deactivate_slider.title}
          type="external-script"
          message={this.localizedExternalScripts.deactivate_slider.sub_text}
          show={this.state.deleteConfirmation}
          onCancel={() => {
            this.setState({
              deleteConfirmation: false,
            });
          }}
        />
      </div>
    );
  }
}

export default ExternalScriptView;
